import React, { useState } from 'react';
import './styles';
import PLDateRangePicker from '../PLDateRangePicker/PLDateRangePicker';
import {
	PHOTOSHOOT_TYPE_SERVICE,
	SCREEN_TYPE,
	USER_ROLE_ADMIN,
	USER_ROLE_AGENT,
	USER_ROLE_PHOTOGRAPHER,
	USER_ROLE_REGIONAL_MANAGER
} from '../../../utils/Config/Constants';
import { FilterIcon, RegionIcon, SortIcon, StageIcon, Trashcan } from '../../../assets/icons';
import UIIcon from '../../UI/UIIcon';
import UIHover from '../../UI/UIHover/UIHover';
import UILabeledInput from '../../UI/UILabeledInput';
import UIModal from '../../UI/UIModal';
import SelectOptionModal from '../../modals/SelectOptionModal';
import { ZendeskAPI } from 'react-zendesk';
import { statusList } from '../../../utils/Config/GeneralConfig';
import UIIconButton from '../../UI/UIIconButton';
import UIOverlayCard from '../../UI/UIOverlayCard';
import { UI_LABELED_INPUT_DROPDOWN_TYPE } from '../../UI/UILabeledInput/config';
import { ORDER_BY_SERVICE, PLFILTER_TYPE_AGENT, PLFILTER_TYPE_FINANCE, PLFILTER_TYPE_PHOTOGRAPHER, PLFILTER_TYPE_SERVICE } from './config';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getReduxFiltersSelector } from '../PLTable/selectors';
import { clearFilter, clearFilters, updateFilter, updatePage } from '../../../redux/store/filters/actions';
import { getSignedInUserSelector } from '../../../redux/selectors/CurrentUserSelectors';
import { getScreenTypeSelector } from '../../../redux/selectors/ControlSelectors';
import { UI_ICON_BUTTON_CANCEL_TYPE } from '../../UI/UIIconButton/config';

export default function PLFilters({ type, updateTable, style }: PLFiltersProps) {
	const filters = useSelector(getReduxFiltersSelector);
	const screenType = useSelector(getScreenTypeSelector);
	const signedInUser = useSelector(getSignedInUserSelector);

	const dispatch = useDispatch();
	const history = useHistory();

	const [isExpanded, setIsExpanded] = useState<boolean>(false);
	const [matchingPath] = useState<string>(history.location.pathname);
	const [selectOption, setSelectOption] = useState<boolean>(false);

	const getNumberOfFiltersEnabled = () => {
		let count = 0;
		if (filters[matchingPath]) {
			count += Object.keys(filters[matchingPath]).filter(
				(key) => ['search_field', 'page', 'search', 'orderBy', 'selectedItem', 'selectedTab'].indexOf(key) === -1
			).length;
		}
		return count;
	};

	const getOrderByOptions = () => {
		if (type === PLFILTER_TYPE_SERVICE) {
			return [
				{ label: 'Date of service', value: ORDER_BY_SERVICE.SERVICE_DATE },
				{ label: 'Date created', value: ORDER_BY_SERVICE.CREATED_AT },
				{ label: 'Date updated', value: ORDER_BY_SERVICE.UPDATED_AT }
			];
		}
		return [];
	};

	const onChangeDate = ({ startDate, endDate }) => {
		if (startDate) {
			dispatch(updateFilter({ route: matchingPath, filter: { name: 'startDate', value: startDate } }));
			dispatch(updatePage({ route: matchingPath, page: 1 }));
		}
		if (endDate) {
			dispatch(updateFilter({ route: matchingPath, filter: { name: 'endDate', value: endDate } }));
			dispatch(updatePage({ route: matchingPath, page: 1 }));
		}
		updateTableWithTimeout();
	};

	const onChangeStatus = (status) => {
		dispatch(updateFilter({ route: matchingPath, filter: { name: 'status', value: status } }));
		dispatch(updatePage({ route: matchingPath, page: 1 }));
		updateTableWithTimeout();
	};

	const onChangeServiceType = (serviceType) => {
		dispatch(updateFilter({ route: matchingPath, filter: { name: 'serviceType', value: serviceType } }));
		dispatch(updatePage({ route: matchingPath, page: 1 }));
		updateTableWithTimeout();
	};

	const onChangeRegion = (region) => {
		dispatch(updateFilter({ route: matchingPath, filter: { name: 'region', value: region } }));
		dispatch(updatePage({ route: matchingPath, page: 1 }));
		updateTableWithTimeout();
	};

	const onChangeOrderBy = (orderBy) => {
		dispatch(updateFilter({ route: matchingPath, filter: { name: 'orderBy', value: orderBy.value } }));
		dispatch(updatePage({ route: matchingPath, page: 1 }));
		updateTableWithTimeout();
	};

	const onChangeOptions = (options) => {
		dispatch(updateFilter({ route: matchingPath, filter: { name: 'options', value: options } }));
		dispatch(updatePage({ route: matchingPath, page: 1 }));
		updateTableWithTimeout();
	};

	const updateTableWithTimeout = () => {
		setTimeout(() => {
			updateTable();
		}, 50);
	};

	const renderClearRouteButton = (value, canClear) => {
		return (
			<div className='clear'>
				{canClear ? (
					<UIHover text={'clear'}>
						<UIIcon
							onClick={() => {
								dispatch(clearFilter({ route: matchingPath, filter: { name: value } }));
								updateTableWithTimeout();
							}}
							className='deleteStyle'
							iconSrc={Trashcan.white}
							alt={'delete'}
						/>
					</UIHover>
				) : undefined}
			</div>
		);
	};

	const renderFilter = () => {
		let pathFilters = filters[matchingPath];
		let startDate = pathFilters ? (pathFilters.startDate ? pathFilters.startDate : undefined) : undefined;
		let endDate = pathFilters ? (pathFilters.endDate ? pathFilters.endDate : undefined) : undefined;

		switch (type) {
			case PLFILTER_TYPE_FINANCE:
				return (
					<div className='filterCard__container'>
						{renderRegionFilter(pathFilters)}
						<PLDateRangePicker startDate={startDate} endDate={endDate} updateTable={updateTable} onDatesChange={onChangeDate} />
					</div>
				);
			case PLFILTER_TYPE_AGENT:
			case PLFILTER_TYPE_PHOTOGRAPHER:
				return <div className='filterCard__container'>{renderRegionFilter(pathFilters)}</div>;
			case PLFILTER_TYPE_SERVICE:
			default:
				return (
					<div className='filterCard__container'>
						{renderOrderByFilter(pathFilters)}
						{renderStageFilter(pathFilters)}
						{renderRegionFilter(pathFilters)}
						{renderServiceTypeFilter(pathFilters)}
						{/*{renderOptionsFilter(pathFilters)}*/}

						<div className='dateOfService'>
							<PLDateRangePicker startDate={startDate} endDate={endDate} updateTable={updateTable} onDatesChange={onChangeDate} />
						</div>
					</div>
				);
		}
	};

	const renderFiltersModal = () => {
		const hideModal = () => setIsExpanded(false);

		const areFiltersEnabledAndNotFinance = getNumberOfFiltersEnabled() > 0 && type !== PLFILTER_TYPE_FINANCE;

		return (
			<UIModal condition={isExpanded}>
				<UIOverlayCard hideModal={hideModal} cardStyle={{ width: 440 }} contentClassName={'filter-container'} title={'filter'}>
					{renderFilter()}
					{areFiltersEnabledAndNotFinance && (
						<div className='filterCard__buttons'>
							<UIIconButton
								dark
								type={UI_ICON_BUTTON_CANCEL_TYPE}
								text={'clear'}
								onClick={() => {
									dispatch(clearFilters());
									updateTableWithTimeout();
								}}
								className='clearBtn'
							/>
						</div>
					)}
				</UIOverlayCard>
			</UIModal>
		);
	};

	const renderServiceTypeFilter = (pathFilters) => {
		if ([USER_ROLE_ADMIN, USER_ROLE_REGIONAL_MANAGER].indexOf(signedInUser.role) === -1) {
			return undefined;
		}
		let isServiceTypeSelected = pathFilters ? pathFilters['serviceType'] !== undefined : false;
		return (
			<div className='filterCard__container--item'>
				{screenType !== SCREEN_TYPE.mobile && (
					<UIHover text={'region'}>
						<UIIcon className='filterCard__container--item-icon' iconSrc={isServiceTypeSelected ? RegionIcon.mint : RegionIcon.white} alt={'region'} />
					</UIHover>
				)}
				<UILabeledInput
					type={UI_LABELED_INPUT_DROPDOWN_TYPE}
					options={[
						{ label: 'Photoshoot', value: PHOTOSHOOT_TYPE_SERVICE },
						{ label: 'Edit', value: 'edit' }
					]}
					onChangeDropdownValue={onChangeServiceType}
					containerStyle={{ marginLeft: 16 }}
					value={pathFilters ? pathFilters['serviceType'] : undefined}
					placeholder='filter by service type...'
				/>
				{renderClearRouteButton('region', isServiceTypeSelected)}
			</div>
		);
	};

	// renderOptionsFilter = (pathFilters) => {
	// 	if ([USER_ROLE_ADMIN, USER_ROLE_REGIONAL_MANAGER].indexOf(this.props.currentUser.user.role) === -1) {
	// 		return undefined;
	// 	}
	// 	let isServiceTypeSelected = pathFilters ? pathFilters['serviceType'] !== undefined : false;
	//
	// 	let selectedOptions = [];
	// 	if (pathFilters.options) {
	// 		selectedOptions = pathFilters.options;
	// 	}
	// 	return (
	// 		<div className='filterCard__container--item'>
	// 			<div className='filterCard__options'>
	// 				<UIButton text={'filter by options'} onClick={() => this.setState({ selectOption: true })} />
	// 				<div className='filterCard__options'>
	// 					{selectedOptions.map((option) => (
	// 						<p
	// 							onClick={
	// 								() => this.onChangeOptions(selectedOptions.filter((selectedOption) => selectedOption.id !== option.id))
	// 								// this.setState({ selectedOptions: selectedOptions.filter(selectedOption => selectedOption.id !== option.id) })
	// 							}
	// 							className='filterCard__options--item'>
	// 							{option.name}
	// 						</p>
	// 					))}
	// 				</div>
	// 			</div>
	// 			{this.renderClearRouteButton('options', isServiceTypeSelected)}
	// 		</div>
	// 	);
	// };

	const renderRegionFilter = (pathFilters) => {
		let isRegionSelected = pathFilters ? pathFilters.region !== undefined : false;
		let regions = signedInUser.regions;
		
		if (regions) {
			if (regions.length > 1) {
				return (
					<div className='filterCard__container--item'>
						{screenType !== SCREEN_TYPE.mobile && (
							<UIHover text={'region'}>
								<UIIcon className='filterCard__container--item-icon' iconSrc={isRegionSelected ? RegionIcon.mint : RegionIcon.white} alt={'region'} />
							</UIHover>
						)}
						<UILabeledInput
							type={UI_LABELED_INPUT_DROPDOWN_TYPE}
							options={regions.map((region) => {
								return { label: region.name, value: region };
							})}
							onChangeDropdownValue={onChangeRegion}
							containerStyle={{ marginLeft: 16 }}
							value={pathFilters ? pathFilters.region : undefined}
							placeholder='filter by region...'
						/>
						{renderClearRouteButton('region', isRegionSelected)}
					</div>
				);
			}
		}

		return undefined;
	};

	const renderStageFilter = (pathFilters) => {
		let isStatusSelected = pathFilters ? pathFilters.status !== undefined : false;

		if ([USER_ROLE_AGENT, USER_ROLE_PHOTOGRAPHER].indexOf(signedInUser.role) !== -1) {
			return undefined;
		}

		return (
			<div className='filterCard__container--item'>
				{screenType !== SCREEN_TYPE.mobile && (
					<UIHover text={'stage'}>
						<UIIcon className='filterCard__container--item-icon' iconSrc={isStatusSelected ? StageIcon.mint : StageIcon.white} alt={'stage'} />
					</UIHover>
				)}
				<UILabeledInput
					type={UI_LABELED_INPUT_DROPDOWN_TYPE}
					options={statusList}
					onChangeDropdownValue={onChangeStatus}
					containerStyle={{ marginLeft: 16 }}
					value={pathFilters ? pathFilters.status : undefined}
					placeholder='filter by stage...'
				/>
				{renderClearRouteButton('status', isStatusSelected)}
				{renderOptionSelectModal()}
			</div>
		);
	};

	const renderOrderByFilter = (pathFilters) => {
		let isOrderBySelected = pathFilters ? pathFilters.orderBy !== undefined : false;

		return (
			<div className='filterCard__container--item'>
				{screenType !== SCREEN_TYPE.mobile && (
					<UIHover text={'sort by'}>
						<UIIcon className='filterCard__container--item-icon' iconSrc={isOrderBySelected ? SortIcon.mint : SortIcon.white} alt={'sort by'} />
					</UIHover>
				)}

				<UILabeledInput
					type={UI_LABELED_INPUT_DROPDOWN_TYPE}
					options={getOrderByOptions()}
					onChangeDropdownValue={onChangeOrderBy}
					containerStyle={{ marginLeft: 16 }}
					value={pathFilters ? pathFilters.orderBy : undefined}
					placeholder='Sort results by...'
				/>
				{renderClearRouteButton('orderBy', isOrderBySelected)}
			</div>
		);
	};

	const renderOptionSelectModal = () => {
		const hideModal = () => setSelectOption(false);
		return (
			<UIModal condition={selectOption}>
				<SelectOptionModal
					hideModal={hideModal}
					selectOption={(selectedOption) => {
						let options: OptionType[] = [];
						if (filters[matchingPath].options) {
							options = [...filters[matchingPath].options];
						}
						options.push(selectedOption);
						onChangeOptions(options);
						setSelectOption(false);
					}}
				/>
			</UIModal>
		);
	};

	return (
		<div className='overlayBtn' style={style} onClick={() => setIsExpanded(true)}>
			<UIIcon
				badgeNumber={getNumberOfFiltersEnabled()}
				className='filterCard__container--item-icon'
				iconSrc={getNumberOfFiltersEnabled() > 0 ? FilterIcon.mint : FilterIcon.white}
				alt={'filters'}
			/>
			{renderFiltersModal()}
		</div>
	);
}
